import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import {
  BtnPurpleTransparent32,
  BtnGreen32,
  TextField,
  TooltipForElement,
  InfoButton
} from '../Elements';

import classes from './TextRedactor.module.scss';

const TextRedactor = ({
  className,
  value,
  onCancel,
  onClickOk,
  textButtonCancel,
  textButtonOk,
  textarea = false,
  newClearRelease,
  headerText,
  disabledBottomPanel
}) => {
  const language = useUserState().user.language;

  const [editName, setEditName] = useState('');
  const [editTitle, setEditTitle] = useState('');

  useEffect(() => {
    setEditName(value);
  }, [value]);

  const onChangeName = e => {
    setEditName(e.target.value);
  };

  const onChangeTitle = e => {
    setEditTitle(e.target.value);
  };
  return (
    <div
      className={cn(
        classes.textRedactor,
        textarea && classes.textRedactor_textarea,
        className,
        !disabledBottomPanel && !textarea && classes.textRedactor_bottomPanel
      )}
    >
      {textarea ? (
        <textarea
          className={classes.textarea}
          value={editName}
          onChange={onChangeName}
        />
      ) : (
        <>
          <div
            className={cn(
              classes.inputBox,
              !disabledBottomPanel && classes.inputBox_bottomPanel,
              newClearRelease && classes.inputBox_newClearRelease
            )}
          >
            <div className={classes.inputWrap}>
              <h3 className={classes.name}>
                {headerText}
                <TooltipForElement
                  text={t('tooltip', 'INFO_NAME_RELEASE', language)}
                  className={classes.info}
                >
                  <InfoButton />
                </TooltipForElement>
              </h3>

              <TextField
                className={classes.inputWrap}
                classNameForInput={classes.input}
                value={editName}
                onChange={onChangeName}
                placeholder={t('textRedactor', 'NAME', language)}
              />
            </div>

            {newClearRelease && (
              <div className={classes.inputWrapHeading}>
                <h3 className={classes.name}>
                  {t('createFirstRelease', 'ADD_HEADING', language)}
                  <TooltipForElement
                    text={t('tooltip', 'INFO_NAME_RELEASE', language)}
                    className={classes.info}
                  >
                    <InfoButton />
                  </TooltipForElement>
                </h3>

                <TextField
                  className={classes.inputWrap}
                  classNameForInput={classes.inputHeading}
                  value={editTitle}
                  onChange={onChangeTitle}
                  placeholder={t('textRedactor', 'HEADING', language)}
                />
              </div>
            )}
          </div>
        </>
      )}
      <div className={classes.buttonBox}>
        <BtnPurpleTransparent32
          onClick={onCancel}
          textButton={
            textButtonCancel
              ? textButtonCancel
              : t('textRedactor', 'CANCEL', language)
          }
          className={classes.buttonCancel}
        />

        <BtnGreen32
          disabled={
            !newClearRelease
              ? editName.length > 0
                ? false
                : true
              : editName.length > 0 && editTitle.length > 0
              ? false
              : true
          }
          onClick={() =>
            onClickOk(
              !newClearRelease ? editName : { name: editName, title: editTitle }
            )
          }
          textButton={
            textButtonOk
              ? textButtonOk
              : textarea
              ? t('textRedactor', 'OK', language)
              : t('textRedactor', 'SAVE', language)
          }
        />
      </div>
    </div>
  );
};

TextRedactor.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onCancel: PropTypes.func,
  onClickOk: PropTypes.func,
  textButtonCancel: PropTypes.string,
  textButtonOk: PropTypes.string,
  textarea: PropTypes.bool,
  newClearRelease: PropTypes.bool,
  headerText: PropTypes.string,
  disabledBottomPanel: PropTypes.bool
};

export default TextRedactor;
